<div class="titleblock">
  <h3 class="title1level">Dati Fascicolo Processo Telematico</h3>
  <p>
    <a href="javascript:void(0)" (click)="openModal()">
      Modifica informazioni <span class="glyphicon glyphicon-pencil"></span>
    </a>
    <a href="javascript:void(0)" (click)="onImportDati()">
      Importa dati <span class="glyphicon glyphicon-save"></span>
    </a>
  </p>
</div>

<div class="container_dati_generali">

  <div class="row">

    <div class="pda-general-data-section">
      <div class="col-sm-6">

        <p>
          <button (click)="updatePct()" aria-label="Aggiorna Dati" class="btn btn-primary">
            Aggiorna Dati  <span class="glyphicon glyphicon-refresh"></span>
          </button>
        </p>

      </div>
      <div *ngIf="model" class="col-sm-6">

        <p>
          <span class="pda-general-data-label">Data ultimo aggiornamento: </span>
          <span class="pda-general-data-value"> {{ model.dataUltimoAggiornamento | date: "dd/MM/YYYY HH:mm" }} </span>
        </p>

        <p>
          <!-- <span class="pda-general-data-label">Stato: </span> -->
          <!-- <span class="pda-general-data-value"> {{ model.status }} </span> -->
        </p>

      </div>
    </div>

  </div>

  <div *ngIf="model" class="row">

    <div class="pda-general-data-section">
      <div *ngIf="isCass">
        <div class="col-sm-6">

          <p>
            <span class="pda-general-data-label">Numero ruolo: </span>
            <span class="pda-general-data-value"> {{ model.numeroRuolo }} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Anno Ruolo: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.annoRuolo) }} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Autorit&agrave;: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.autorita) }} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Localit&agrave;: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.autorita) }} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Materia: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.materia)}} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Registro: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.registro) }} </span>
          </p>

        </div>
        <div class="col-sm-6">

          <p>
            <span class="pda-general-data-label">Data Deposito: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.dataDeposito) | date: "dd/MM/YYYY HH:mm" }} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Parti: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.partiText) }} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Sezione: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.sezione) }} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Data Udienza: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.dataUdienza) | date: "dd/MM/YYYY HH:mm" }} </span>
          </p>

          <p>
            <span class="pda-general-data-label">Tipo Udienza: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.tipoUdienza) }} </span>
          </p>

        </div>
      </div>
      <div *ngIf="!isCass">
        <div class="col-sm-6">
          <p>
            <span class="pda-general-data-label">Numero ruolo: </span>
            <span class="pda-general-data-value"> {{ model.numeroRuolo }} </span>
          </p>
          <p>
            <span class="pda-general-data-label">Anno Ruolo: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.annoRuolo) }} </span>
          </p>
          <p>
            <span class="pda-general-data-label">Oggetto: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.oggetto) }} </span>
          </p>
          <p>
            <span class="pda-general-data-label">Materia: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.materia)}} </span>
          </p>
          <p>
            <span class="pda-general-data-label">Registro: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.registro) }} </span>
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            <span class="pda-general-data-label">Data iscrizione RG: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.dataIscrizioneRg) | date: "dd/MM/YYYY HH:mm" }} </span>
          </p>
          <p>
            <span class="pda-general-data-label">Grado giudizio: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.grado) }} </span>
          </p>
          <p>
            <span class="pda-general-data-label">Atto Introduttivo: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.atto) }} </span>
          </p>
          <p>
            <span class="pda-general-data-label">Costituzione in giudizio: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.costituzioneGiudizio) }} </span>
          </p>
          <p>
            <span class="pda-general-data-label">Sezione/Giudice: </span>
            <span class="pda-general-data-value"> {{ replaceNull(model.sezione) }}/{{ replaceNull(model.giudice) }} </span>
          </p>
        </div>
      </div>
    </div>

  </div>

</div>

<app-pda-section-nodata *ngIf="!model" ></app-pda-section-nodata>

